import { render, staticRenderFns } from "./leaflet-map-image-overlay.vue?vue&type=template&id=3f0badb4"
import script from "./leaflet-map-image-overlay.vue?vue&type=script&lang=ts"
export * from "./leaflet-map-image-overlay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/apps/front/flightpath-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f0badb4')) {
      api.createRecord('3f0badb4', component.options)
    } else {
      api.reload('3f0badb4', component.options)
    }
    module.hot.accept("./leaflet-map-image-overlay.vue?vue&type=template&id=3f0badb4", function () {
      api.rerender('3f0badb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flightpath-components/lib-components/leaflet-map-image-overlay.vue"
export default component.exports